import {PHASES, WAR_PHASE_STAGES} from "../../../constants/phases";

/**
 * Показывается ли сейчас в футере Расчет урона, который нанёс выбранный отряд
 * (SelectedUnitMelee): этап ближнего боя, отряд выбран, режим выбора
 * приоритетной цели не включен, и по этому отряду расчет боя уже пришел.
 *
 * Условие общее для трех мест: заголовка футера (useFooterTitle), кнопки
 * снятия выбора рядом с ним и футера режима зрителя, где от него зависит,
 * показывать ли контейнер футера вообще. Держать его в одном месте важно —
 * разъехавшись, они дали бы заголовок без панели или наоборот.
 *
 * @param {Object} params
 * @param {string} params.phase
 * @param {string} params.warPhaseStage
 * @param {Object} params.selectedUnit - выбранный отряд (не только id: отряд
 *   мог уже погибнуть в бою, оставшись в расчете)
 * @param {boolean} params.showMeleeTargets - включен выбор приоритетной цели
 * @param {Array} params.pendingMeleeDamage - расчет боя по отрядам
 * @returns {boolean}
 */
export const checkIfMeleeDamageDetailsShown = ({
  phase, warPhaseStage, selectedUnit, showMeleeTargets, pendingMeleeDamage,
}) => {
  return phase === PHASES.WAR
    && warPhaseStage === WAR_PHASE_STAGES.COMBAT
    && Boolean(selectedUnit)
    && !showMeleeTargets
    && Boolean(pendingMeleeDamage?.some((action) => action.unitId === selectedUnit.id));
};
